<template>
  <div class="container">
    <div class="button1">
      <el-button @click="handleClick">
        <img src="../assets/img_home/无标题.png" alt="">
        <p style="margin-top: 25px">客户管理</p>
      </el-button>
    </div>
    <div class="button1">
      <el-button @click="handleFindClick">
        <img src="../assets/img_home/无标题.png" alt="">
        <p style="margin-top: 25px">客户查询</p>
      </el-button>
    </div>
<!--    <div class="button1">-->
<!--      <el-button @click="handleDealerClick">-->
<!--        <img src="../assets/img_home/经销商.png" alt="" style="height: 51px;width: 59px">-->
<!--        <p >经销商列表</p>-->
<!--      </el-button>-->
<!--    </div>-->
  </div>
</template>

<script>
  export default {
    name: "Home",
    methods:{
      handleClick(){
        this.$router.push('customer');
      },
      handleFindClick(){
        this.$router.push('findCustomer');
      },
      handleDealerClick(){
        this.$router.push('dealer');
      },
    }
  }
</script>

<style scoped>
  .container{
    display: flex;
    flex-wrap: wrap;
  }
  .button1 {
    width: 120px;
    height: 120px;
    background-color: #eeeeee;
    text-align: center;
    align-content: center;
    box-shadow: inset 1px 1px 2px #ccc;
    border-radius: 2px;
    margin: 10px 10px;
  }

  .el-button {
    width: 100px;
    height: 100px;
    margin: auto;
    border-radius: 2px;
  }

  .el-button img {
    width: 64px;
    height: 40px;
  }

  P{
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue